import { useMutation } from '@ts-gql/apollo';
import { gql } from '@ts-gql/tag';
import React from 'react';

const mutation = gql`
  mutation UpdateUserFilter($input: UserFilterUpdateInput!) {
    updateUserFilter(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
      success
    }
  }
` as import('../../__generated__/ts-gql/UpdateUserFilter').type;

export const useUpdateUserFilter = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'users' },
        ...(options.variables && {
          refetchQueries: ['GetUserFilter', 'GetUserFilterList'],
        }),
        awaitRefetchQueries: true,
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
